import { render, staticRenderFns } from "./ActiveReg.vue?vue&type=template&id=781a3dd4&"
import script from "./ActiveReg.vue?vue&type=script&lang=js&"
export * from "./ActiveReg.vue?vue&type=script&lang=js&"
import style0 from "./ActiveReg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports